import { BALANCE_ESTIMATE_RANGES } from "@/shared/constants/balanceEstimates";

import type { EstateItem } from "@/shared/types/estateTypes";

export function isEstimatedItem(item: EstateItem): boolean {
  return item.is_estimated === true;
}

export function getEstimateRangeLabel(item: EstateItem): string | null {
  if (!isEstimatedItem(item) || !item.balance_estimate_range) return null;
  const range = BALANCE_ESTIMATE_RANGES.find((r) => r.key === item.balance_estimate_range);
  return range?.label ?? null;
}

export function isUnsureEstimate(item: EstateItem): boolean {
  return isEstimatedItem(item) && item.balance_estimate_range === "unsure";
}

export function getEstimateMidpoint(key: string): number {
  const range = BALANCE_ESTIMATE_RANGES.find((r) => r.key === key);
  return range?.midpoint ?? 0;
}

export function resolveBalance(
  balanceUnknown: boolean,
  estimateRange: string,
  value: string,
): number {
  return balanceUnknown ? getEstimateMidpoint(estimateRange) : parseFloat(value);
}
